import { Request } from 'commons/utils/request'

export const deleteApplication = (id: number) => Request.delete<number>(Request.urls.bank.application, { id: id })

export const getApplicationLink = (id: number) =>
  Request.post<{ link: string }>(Request.urls.bank.applicationLink, { id: id })
